(() => {
  window.swinger.observer.initialize('.swinger-scene .swinger-hero', (elem) => {
    const sceneElem = elem.closest('.swinger-scene');

    window.swinger.visibility.observe(elem, (visible) => {
      sceneElem.classList[visible ? 'remove' : 'add']('swinger-scene--hero-invisible');
    });
  }, false);
})();
